import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const EventCardImage = ({ imageUrl, alt, heading, url, isExternalLink }) => {
  if (!imageUrl) imageUrl = 'https://placehold.co/600x400?text=Image+Unavailable&font=roboto';
  return (
    <>
      <div className="event-cards__image-wrapper">
        <a href={url} target={isExternalLink ? '_blank' : '_self'} rel={isExternalLink ? 'noopener noreferrer' : ''}>
          <LazyLoadImage src={imageUrl} effect="opacity" alt={alt ? alt : heading} className="event-cards__image"></LazyLoadImage>
        </a>
      </div>
    </>
  );
};
export default EventCardImage;
